export default [
  {
    name: 'environmentMapTexture',
    type: 'cubeTexture',
    path: [
      '../assets/textures/environmentMaps/0/px.jpg',
      '../assets/textures/environmentMaps/0/nx.jpg',
      '../assets/textures/environmentMaps/0/py.jpg',
      '../assets/textures/environmentMaps/0/ny.jpg',
      '../assets/textures/environmentMaps/0/pz.jpg',
      '../assets/textures/environmentMaps/0/nz.jpg',
    ],
  },
  {
    name: 'floorColorTexture',
    type: 'texture',
    path: '../assets/textures/floor/baseColor.jpg',
  },
  {
    name: 'floorNormalTexture',
    type: 'texture',
    path: '../assets/textures/floor/normal.jpg',
  },
  {
    name: 'foxModel',
    type: 'gltfModel',
    path: '../assets/models/Fox/glTF/Fox.gltf',
  },
]
